import Api from './api'
import response from 'fe-coms/utils/response'
import Vue from '@/app.js'
const http = new Vue().$http

const action = {
  // 获取商城设置规则
  async updateMallRule ({commit}) {
    return new Promise(async (resolve) => {
      const api = Api.mallSetting
      const res = await response(http(api.type, api.url))
      if (res.isOk) {
        /**
         * isMarketPrice //市场价 0: "不展示" 1: "展示"
         * includedTax  0: "不含税" 1: "含税"
         * displayPrice 0: "协议价" 1: "参考价"
         * isShowOrganize //采购组织 0: "不展示" 1: "展示"
        */
        const ruleObj = res.content || {}
        commit('UPDATE', ruleObj)
        resolve(true)
      }
    })
  },
  async initMallRule ({state, dispatch}) {
    // 缓存5s
    if (state._updatedAt + 5000 > new Date().getTime()) {
      return
    }
    // 获取新的规则
    await dispatch('updateMallRule')
  }
}

export default action
